import { Component, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { AppState, ShowRequest } from '../../core';
import { AppTab } from '../../core/app-tab';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { ImportFileListComponent } from '../import-file-list/import-file-list.component';
import { ImportedFileEvent } from '../import-file/import-file.component';

@Component({
  selector: 'app-import-file-panel',
  templateUrl: './import-file-panel.component.html',
  styleUrls: ['./import-file-panel.component.css']
})
export class ImportFilePanelComponent extends FesBaseComponent implements OnInit, OnDestroy {

  @Input() set tabConfig( tabConfig : AppTab ) {
    tabConfig.setSelected = this.onTabSelected
  }

  @Input('detailFn') public detailFn : (vi: ShowRequest) => void;

  @ViewChild('importFileList') importFileList: ImportFileListComponent;


  ngOnInit(): void {
    
  }

  constructor( appState: AppState ) {
    super(appState)
  }

  initialize(){
    this.appState.doWhenReady( () => {
      this.importFileList?.load()
    })
  }


  ngOnDestroy(): void {
    this.destroy()
  }
  

  onTabSelected = ( bSelected : boolean ) => {
    console.log('import file tab selected: ' + bSelected )
    if ( bSelected ) {
      this.initialize()
    } else {
      //this.unsubscribe()
    }
  }

  showView( viewName: string, itemId: string = null) {
    this.detailFn( new ShowRequest('tab',viewName, itemId) )
  }

  onFileImported( importFileEvent : ImportedFileEvent) {
    this.importFileList?.load()
  }

  onFileImportFailed( {fileName,error} : {fileName:string, error: any}) {
    console.error('Error importing ', fileName, ', error', error);
    this.importFileList?.load()
  }

}
